module.exports = __webpack_public_path__ + "img/yhpc-img01.29e926ce.png";